module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.errors).length) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._l((_vm.errors), function(error) {
    return _vm._l((error), function(v) {
      return _c('p', [_vm._v(_vm._s(v))])
    })
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2bfcc7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/Error.vue
// module id = 488
// module chunks = 1